import { MapActionsSnackbarModule } from '@/store/snackbar/map-actions.snackbar';
import { RegraInterface } from '@/shared/models/regra/regra.interface';
import { RegraFilter } from '@/shared/models/regra/regra.filter';
import store from '@/store';
import queryUtil from '@/shared/utils/query.util';
import { instanciaAxios } from './base.service';

const regras = 'regras';

export default class RegraService {
  async buscarTodas(): Promise<any> {
    return await instanciaAxios.get(regras)
      .then((response: any) => {
        const lista: Array<RegraInterface> = response.data;
        return lista;
      })
      .catch((error: any) => {
        store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_ERROR, error);
        console.error(error);
      });
  }

  async buscarPorCodigo(codigo: string): Promise<any> {
    return await instanciaAxios.get(`${regras}/${codigo}`)
      .then((response: any) => {
        const regra: RegraInterface = response.data;
        return regra;
      })
      .catch((error: any) => {
        store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_ERROR, error);
        console.error(error);
      });
  }

  async buscarPorFiltro(filtro: RegraFilter): Promise<any> {
    const query = queryUtil.getQuery(filtro);
    return await instanciaAxios.get(`${regras}/pesquisa${query}`)
      .then((response: any) => {
        const lista: Array<RegraInterface> = response.data;
        store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_SUCCESS, 'Pesquisa concluída!');
        return lista;
      })
      .catch((error: any) => {
        store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_ERROR, error);
        console.error(error);
      });
  }

  async salvar(body: RegraInterface): Promise<any> {
    await instanciaAxios.post(regras, body)
      .then(() => {
        store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_SUCCESS, 'Regra cadastrada com sucesso!');
      })
      .catch((error: any) => {
        console.error(error.response);
        store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_ERROR, error.response.data);
        return Promise.reject();
      });
  }

  async atualizar(body: RegraInterface): Promise<any> {
    await instanciaAxios.put(`${regras}/${body.codigo}`, body)
      .then(() => {
        store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_SUCCESS, 'Regra editada com sucesso!');
      })
      .catch((error: any) => {
        console.error(error.response);
        store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_ERROR, error.response.data);
        return Promise.reject();
      });
  }

  async excluir(regra: RegraInterface): Promise<any> {
    await instanciaAxios.delete(`${regras}/${regra.codigo}`)
      .then(() => {
        store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_SUCCESS, 'Regra excluída com sucesso!');
      })
      .catch((error) => {
        console.error(error.response);
        store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_ERROR, error.response.data);
        return Promise.reject();
      });
  }
}
